import React, { PropTypes } from 'react';
import { Tabs, Modal, Input, Icon, Button, Upload, message, Spin } from 'antd';
import DataService from '../../lib/DataService';
import UserRoleStore from '../../stores/UserRoleStore';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import CreateNotificationsComponent from './notificationComponents/createNotificationsComponent'
import ViewClassesWithNotificationsComponent from './notificationComponents/viewClassesWithNotificationsComponent'
import ViewNotificationsOfClassComponent from './notificationComponents/viewNotificationsOfClassComponent'
const TabPane = Tabs.TabPane;
const { TextArea } = Input;

export default class NotificationsOfClassPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      classId: props.params.classId,
      currentRole: CurrentRoleStore.getCurrentRole(),
    };

    if (!this.state.schoolId  && this.state.currentRole.associatName == "school") {
      this.state.schoolId = this.state.currentRole.associatObj.id;
    } else {
      this.state.schoolId = this.state.currentRole.associatObj.schoolId;
    }
    // bind this
    this.onRolesChange = this.onRolesChange.bind(this);
  }

  componentDidMount(){
    UserRoleStore.addChangeListener(this.onRolesChange);
    DataService.getClassById(this.state.classId).then(response => {
      this.setState({
        className: response.name
      });
    }, error => {
      console.log(error);
      message.error("读取数据失败，请稍后重试");
    });
  }

  componentWillUnmount(){
    UserRoleStore.removeChangeListener(this.onRolesChange);
  }

  onRolesChange() {
    this.setState({
      currentRole: CurrentRoleStore.getCurrentRole(),
    });
  }

  render() {
    return (
      <div className="notifications-page">
        <div className="current-class-info">{this.state.className}通知内容</div>
        <ViewNotificationsOfClassComponent currentRole={this.state.currentRole} classId={this.state.classId} />
      </div>
    )
  }
}






// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/classinfo/NotificationsOfClassPage.jsx